import { useCallback } from 'react';
import Amplitude from 'utils/amplitude';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import usePlaidLink from 'hooks/usePlaidLink';
import AddAccountModal from 'features/accounts/components/AddAccountModal';
import { useAppSelector } from 'store/hooks';
import { selectSelectedSpace } from 'features/spaces/reducers/selectors';
export const useAddAccountModal = (title, spaceId) => {
    const navigation = useMainStackNavigation();
    const openPlaid = usePlaidLink();
    const currentSpaceId = useAppSelector(selectSelectedSpace);
    const addAccount = useCallback(() => {
        Amplitude.logEvent('Accounts.OpenAddAnAccount');
        AddAccountModal.show({
            navigate: navigation.navigateDeprecated,
            onAddProperty: title === 'Net worth'
                ? () => {
                    navigation.navigateDeprecated('Property', {
                        spaceId: spaceId || currentSpaceId,
                    });
                }
                : undefined,
            onOpenPlaid: openPlaid,
            onAddOffline: () => {
                const cash = title === 'Cash' ||
                    title === 'Checking' ||
                    title === 'Current' ||
                    title === 'Everyday';
                const debt = title === 'Debt';
                const netWorth = title === 'Net worth';
                let params = {}; // TODO: refactor this. Use a separate key instead of mixing AccountType with some random strings.
                if (cash || debt || netWorth) {
                    const pickAccountTypeParams = {
                        type: (() => {
                            if (cash) {
                                return 'CHECKINGCARDS';
                            }
                            if (debt) {
                                return 'DEBT';
                            }
                            return undefined;
                        })(),
                    };
                    navigation.navigateDeprecated('PickAccountType', {
                        ...pickAccountTypeParams,
                        spaceId: spaceId || currentSpaceId,
                    });
                }
                else {
                    const addBalanceParams = {
                        type: (() => {
                            if (title === 'Savings') {
                                return 'SAVINGS';
                            }
                            if (title === 'Investments') {
                                return 'INVESTMENT';
                            }
                            return undefined;
                        })(),
                    };
                    params = addBalanceParams;
                    navigation.navigateDeprecated('DummyAccountSetup', addBalanceParams);
                }
                Amplitude.logEvent('Accounts.DummyAccountSetup', params);
            },
            spaceId: spaceId || currentSpaceId,
        });
    }, [currentSpaceId, openPlaid, spaceId, title]);
    return addAccount;
};
